import { Inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { HttpClient } from '@angular/common/http';
import { Environment } from '../../types/environment';
import { PackageType } from '../../types/package-type';

@Injectable({
  providedIn: 'root',
})
export class PackageTypeService {
  readonly API = `${this.env.apiUrl}/packageTypeClassifier`;
  constructor(
    @Inject(APP_ENVIRONMENT) private readonly env: Environment,
    private readonly http: HttpClient,
  ) {}

  create() {
    return this.http.post<PackageType>(`${this.API}/create`, null);
  }

  update(packageType: PackageType) {
    return this.http.post<PackageType>(`${this.API}/save`, packageType);
  }

  getById(id: number) {
    return this.http.get<PackageType>(`${this.API}/getById?id=${id}`);
  }

  getAll(code?: string) {
    let url = `${this.API}/getAll`;
    if (code) {
      url += `?code=${code}`;
    }
    return this.http.get<PackageType[]>(url);
  }

  deleteById(id: number) {
    return this.http.post<void>(`${this.API}/deleteById?id=${id}`, null);
  }

  toPackageTypeMap(
    value: PackageType[],
    key: keyof PackageType,
  ): Map<string, PackageType> {
    return value.reduce((previousValue, currentValue) => {
      return previousValue.set(currentValue[key]?.toString(), currentValue);
    }, new Map());
  }
}
